<template>
  <MainLayout class="video-courses">
    <div class="container mw-960" slot="sub-header">
      <div class="row">
        <div class="col-sm-10">
          <nav class="navbar navbar-toggleable navbar-light">
            <ul class="nav navbar-nav">
              <li class="nav-item active">
                <router-link to="/video-courses" class="nav-link typography--body-3">
                  {{ $t('video_lectures.sub_header.video_courses') }}
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/video-lectures" class="nav-link typography--body-3">
                  {{ $t('video_lectures.sub_header.video_lectures') }}
                </router-link>
              </li>
            </ul>
          </nav>
        </div>

        <div class="col-sm-2 hidden-xs-down">
          <div class="sub-header-btn-row">
            <router-link to="/new-video-course" class="btn btn-primary new-video-course-btn float-right">
              {{ $t('video_lectures.sub_header.new_video_course') }}
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="container mw-960 mt-27" slot="layout-body">
      <div class="row" v-if="loading">
        <div class="col-12 text-center">
          <LoadingBounce />
          <div class="typography--body-2 typography--color-disabled pb-5">
            {{ $t('common.loading') }}
          </div>
        </div>
      </div>

      <div class="row list-group" v-else>
        <div class="col-12 text-center mb-5 pb-5" v-if="videoCourseList.length === 0">
          <div class="empty-list-text">
            <div class="typography--body-2 typography--color-disabled"
                 v-html="$t('video_lectures.no_course')">
            </div>
          </div>
        </div>

        <div class="list-group-item"
             v-for="videoCourse in videoCourseList"
             :key="videoCourse.id"
             v-else>

          <router-link :to="`/video-courses/${videoCourse.id}`">
            <VideoCourseItem :course="videoCourse" />
          </router-link>

          <div class="ml-auto">
            <router-link class="btn btn-primary" :to="`/video-courses/${videoCourse.id}/edit`">
              {{ $t('common.edit') }}
            </router-link>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <button class="btn btn-primary"
                    @click="showUpdateCourseLecturesShareLevelModal(videoCourse.id, publicShareLevel)">
              {{ $t('common.video_lectures.share_level.public') }}
            </button>

            <button class="btn btn-outline-primary"
                    @click="showUpdateCourseLecturesShareLevelModal(videoCourse.id, privateShareLevel)">
              {{ $t('common.video_lectures.share_level.private') }}
            </button>
          </div>
        </div>

        <InfiniteLoading :on-infinite="onInfinite" ref="infiniteLoading" class="w-100">
          <div slot="spinner">
            <LoadingBounce></LoadingBounce>
            <div class="typography--body-2 typography--color-disabled pb-5">{{ $t('common.loading') }}</div>
          </div>

          <div slot="no-more" class="col-12 text-center mb-5 pb-5">
          </div>
        </InfiniteLoading>
      </div>
    </div>

    <div slot="modal-area">
      <b-modal id="make-video-course-lectures-public-modal"
               class="basic-modal no-header-modal"
               :hide-header="true"
               :close-title="$t('common.cancel')"
               :ok-title="$t('common.confirm')"
               @ok="updateCourseLecturesShareLevel(publicShareLevel)"
               @cancel="courseIdToUpdateShareLevel = null">
        <div v-html="$t('video_lectures.modals.make_course_lectures_public.message')"></div>
      </b-modal>

      <b-modal id="make-video-course-lectures-private-modal"
               class="basic-modal no-header-modal"
               :hide-header="true"
               :close-title="$t('common.cancel')"
               :ok-title="$t('common.confirm')"
               @ok="updateCourseLecturesShareLevel(privateShareLevel)"
               @cancel="courseIdToUpdateShareLevel = null">
        <div v-html="$t('video_lectures.modals.make_course_lectures_private.message')"></div>
      </b-modal>
    </div>
  </MainLayout>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import InfiniteLoading from 'vue-infinite-loading';
  import publisherOnly from '@/mixins/publisherOnly';
  import VideoCourseItem from '../components/VideoCourseItem';

  export default {
    name: 'video-course-list',

    mixins: [
      publisherOnly,
    ],

    components: {
      InfiniteLoading,
      VideoCourseItem,
    },

    data() {
      return {
        loading: false,
        courseIdToUpdateShareLevel: null,
        publicShareLevel: 1,
        privateShareLevel: 2,
      };
    },

    computed: {
      ...mapGetters([
        'videoCourseList',
        'currentUserId',
      ]),
    },

    methods: {
      ...mapActions([
        'updateVideoCourseLecturesShareLevel',
        'fetchVideoCourseList',
      ]),

      showUpdateCourseLecturesShareLevelModal(courseId, shareLevel) {
        this.courseIdToUpdateShareLevel = courseId;

        if (shareLevel === this.publicShareLevel) {
          return this.$root.$emit('show::modal', 'make-video-course-lectures-public-modal');
        }

        return this.$root.$emit('show::modal', 'make-video-course-lectures-private-modal');
      },

      updateCourseLecturesShareLevel(shareLevel) {
        const params = {
          id: this.courseIdToUpdateShareLevel,
          share_level: shareLevel,
        };

        return this.updateVideoCourseLecturesShareLevel(params);
      },

      onInfinite() {
        const perPage = 10;
        const page = parseInt(this.videoCourseList.length / perPage, 10) + 1;
        const params = {
          owner_id: this.currentUserId,
          order_by: '-created_at',
          per_page: perPage,
          page,
        };

        return this.fetchVideoCourseList(params)
          .then((videoCourseList) => {
            if (this.$refs.infiniteLoading) {
              this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');

              if (videoCourseList.length < perPage) {
                this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
              }
            }
          });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/app/video-courses/views/VideoCourseList.vue